export interface RegisteredItemProductPaymentMethod {
  type: 'recurringCard';
}
